import React from "react";
import {Form} from 'react-bootstrap';

function STCFormControlFeedback(props){

    return(
        <Form.Control.Feedback
            style={props.style}
            className={props.className}

            type={props.type}
        >
            {props.children}
        </Form.Control.Feedback>
    )
}
export default STCFormControlFeedback;